module.exports = __webpack_public_path__ + "static/media/tbtc.64de83a0.svg";